import {
  DomainId,
  DomainsDescription,
  JoinDescriptionId,
} from '@models/feature-descriptor-domain';
import { DescriptionsTree } from '../models';

export function createDomainPredicate(
  selectedDomains: Record<DescriptionsTree.NodeId, DomainId[]>,
  selectedJoinIds: JoinDescriptionId[]
) {
  const joinIds = new Set(selectedJoinIds);

  const domainIds = Object.values(selectedDomains).flatMap(d =>
    d.filter(({ joinId }) => (joinIds.size ? joinIds.has(joinId) : true))
  );

  return (description: DomainsDescription) => {
    return domainIds.length
      ? description.domains.some(x =>
          domainIds.find(
            ({ domainIdx, joinId }) =>
              x.joinId === joinId && x.domainIdx === domainIdx
          )
        )
      : joinIds.size
      ? description.domains.some(({ joinId }) => joinIds.has(joinId))
      : true;
  };
}
